




















import Vue from 'vue';

export default Vue.extend({
  name: 'login',
  data: () => ({
    username: '',
    password: '',
    tenant: 'FKD',
    loading: false
  }),
  methods: {
    async login () {
      try {
        this.loading = true;

        const { username, password } = this;
        await this.$store.dispatch('AUTH_REQUEST', { username, password });
        this.$router.push('/');

      } finally {
        this.loading = false;
      }
    }
  }
});
